<template>
  <v-app>
    <v-app-bar app>
      <div class="d-flex align-center">
        <router-link to="/" @click="A11()" id="logo">
          <v-img alt="Logo" class="shrink mr-2" contain src="./assets/img/logo.png" transition="scale-transition"
            width="70" />
        </router-link>
      </div>
      <v-spacer></v-spacer>
      <v-img @click="showMenu=true;$addTags(tags.Menu,null,null,null)" class="shrink ml-2" contain
        src="./assets/img/menu.png" width="40" />
    </v-app-bar>
    <v-main>
      <router-view :userInfo='userInfo'  :inv_number="inv_number" :inv_prize="inv_prize"
        @changeAeMember="changeAeMember" />
    </v-main>
    <div class="nav" v-if="showMenu" @click="showMenu=false; ">
      <v-img class="shrink ml-2" contain src="./assets/img/menuX.png" width="40" />
      <router-link v-if="dateLine" to="/fromPage" @click.native="$addTags(tags.formPage,null,null,null)">發票登錄</router-link> 
      <a href="#" v-if="dateLine" @click="getIsDraw(), $addTags(tags.gamePage,null,null,)">春風貓轉盤</a> 
      <a href="#/#prize" @click=" $addTags(tags.prize,null,null ,{path: '#/#prize'})">活動獎項</a>
      <a href="#/#gift" @click=" $addTags(tags.gift,null,null ,{path: '#/#gift'})">指定通路禮</a>
      <a href="#/#illustrate" @click="$addTags(tags.illustrate,null,null ,{path: '#/#illustrate'})">活動辦法</a>
      <a href="#/#winning" @click="$addTags(tags.winning,null,null ,{path: '#/#winning'})">中獎名單</a>
      <a href="#" @click="goAeSHOP(), $addTags(tags.goAeSHOP,null,null ,null)">加入AeSHOP會員</a>
      <!-- <router-link to="/friendPage" @click.native="$addTags(tags.friendPage,null,null ,null)">邀請LINE好友</router-link> -->
      <router-link to="/" v-if="userInfo.isInvoiceEnrollment" @click.native="getSellerInvoiceVerifyResult()">查詢指定通路發票
      </router-link>
    </div>
    <footer><br>2022 正隆股份有限公司 © All Rights Reserved.<br>
      This site is protected by reCAPTCHA and the Google <br><a href="”https://policies.google.com/privacy”">Privacy
        Policy</a> and <a href="”https://policies.google.com/terms”">Terms of Service</a> apply.<br>
    </footer>
    <popup :popupIconType="popupIconType" :popupItem="popupItem" :sellerName='sellerName'  v-if="dialog"
      @popupStatus="dialog=false" />
  </v-app>
</template>

<script>
  import axios from "axios";
  import liff from '@line/liff';
  import swal from 'sweetalert2';
  import popup from './components/popup'
  export default {
    name: 'App',
    components: {
      popup,
    },
    data: () => ({
      dateLine:new Date()<new Date('2022-12-1,23:59:59'),//活動結束時間
      dialog: false,
      popupIconType: 'Bill',
      popupItem: 'Bill',
      inv_number: '',
      inv_prize: '',
      showMenu: false,
      sellerName: [], //查詢指定通路發票
      audit: false, //指定通路發票審核
      userInfo: [], //取得使用者inviteCode:邀請碼、isAeMember:是否是會員、isDraw：是否玩輪盤、isInvoiceEnrollment:是否登入發票      
      lineProfile: '', //取得user資訊      
      liffId: /(192.168|localhost)/.test(window.location.href) ? "1656433734-Av3Nlql3" : process.env.NODE_ENV ==
        'production' ? "1655166006-PrwQEl4w" : "1656433734-Deg8qRqg",
      // 正式站                      測試站
      tags: {
        "Menu": '7B4BB5430B57449FB7C8AD92BB94AC7C',
        "formPage": '7312DD2792D04452A8D950D6E07B033A',
        "gamePage": '026A2813292C46039EFBFA8E0533E0A5',
        "prize": '0239D525569E42BB9C675C3815DE35F4',
        "gift": '9CC79DE7C79144A8AC51B435EC628B3E',
        "illustrate": '956CAC6ED0D445B5AEAF295C8B21922E',
        "winning": '7A95024891094952BFEBE8B837797F92',
        "goAeSHOP": 'AA81006F0C9648A6B1C5CE112E86ADA0',
        "friendPage": '7AB1E9F7B152489F8B7708F92643D46C'
      },
    }),

    mounted() {
      // document.getElementById("logo").click();
      let _this = this;
      liff.init({
        liffId: _this.liffId,
        withLoginOnExternalBrowser: true
      }).then(() => {
        //確認登入狀態
        if (!liff.isLoggedIn()) {
          //執行登入
          liff.login({
            redirectUri: location.href
          });
        } else {
          // 新增邀請紀錄
          // _this.addInvitationRecord()
          //取得Line Token                
          _this.$SetAccessToken(liff.getAccessToken());
          // User資訊
          _this.getUserInfo()
          //確認好友狀態
          liff.getFriendship().then(async (data) => {
            if (!data.friendFlag) {
              swal.fire({
                text: '請加入春風官方帳號好友',
                allowOutsideClick: false
              }).then(() => {
                // 判斷是否是開發環境
                var isDev = /(192.168|localhost|thor.iprefer|hulk.iprefer)/.test(window.location.href);
                window.location.href = isDev ? 'https://line.me/R/ti/p/@374zoemd' :
                  'https://line.me/R/ti/p/@andantetissue';
              })
              // _this.showPopup = true
              // 做一個popup，有顆按鈕可以導到加好友畫面
            } else {
              try {
                //取得user資訊
                _this.lineProfile = await liff.getProfile();
                // console.log("lineProfile",_this.$accessToken,)
                // console.log("$accessToken",_this.lineProfile)
              } catch (error) {
                alert('忙碌中，請稍後再試');
                console.error(error);
              }
            }
          })
        }
      });
      // window.addEventListener("resize", this.renderResize, true);
    },
    beforeDestroy() {
      // 移除 監聽
      // window.addEventListener("resize", this.renderResize, false);
    },
    methods: {
      //取得指定通路送好禮審核結果
      getSellerInvoiceVerifyResult() {
        var me = this;
        var config = {
          method: "get",
          headers: {
            Authorization: `Bearer ${me.$accessToken}`,
          },
          url: me.$apiUrl + '/liff/GetDataTable_SellerInvoiceVerifyResult/7978B4EB00EB4F77998CA206E06E5A5C',
        }
        swal.fire({
          allowOutsideClick: false
        });
        swal.showLoading();
        axios(config).then(res => {
          var data = res.data;
          if (data && data.success) {
            me.sellerName = data.data ? JSON.parse(data.data) : [];
            console.log('me.sellerName', me.sellerName)
            me.seePopUp('Bill')
          }
        }).catch((err) => {
          console.log(err)
          alert("系統忙碌中，請稍後再試");
        }).finally(() => {
          swal.close();
        })
      },
      // 顯示popup視窗
      seePopUp(val) {
        this.dialog = true
        this.popupIconType = 'icon' + val
        this.popupItem = val
      },
      //獲得使用者是否需要玩輪盤的資訊
      getIsDraw() {
        let me = this;
        var config = {
          method: "get",
          headers: {
            Authorization: `Bearer ${me.$accessToken}`,
          },
          url: me.$apiUrl + '/Liff/GetData_LatestInvoice/A2215DDFC6D841D894DF0AC91697364D',
        }
        swal.fire({
          allowOutsideClick: false
        });
        swal.showLoading();
        axios(config).then(res => {
          var data = res.data;

          if (data && data.success) {
            me.inv_number = data.data.inv_number
            me.inv_prize = data.data.prize
            me.$router.push({
              name: 'gamPage',
              params: {
                inv_number: me.inv_number,
                inv_prize: me.inv_prize,
              }
            })
          } else {
            alert(data.message)
            // 登入發票
            me.$router.push({
              name: 'fromPage',
            })
          }
        }).catch((err) => {
          console.log(err)
          alert("系統忙碌中，請稍後再試");
        }).finally(() => {
          swal.close();
        })
      },
      // 在line liff裡開網頁
      goAeSHOP() {
        liff.openWindow({
          url: "https://pse.is/4f5ggc",
          external: false,
        });
      },
      //取得使用者inviteCode:邀請碼、isAeMember:是否是會員、isDraw：是否玩輪盤、isInvoiceEnrollment:是否登入發票
      getUserInfo() {
        var me = this;
        var config = {
          method: "post",
          headers: {
            Authorization: `Bearer ${me.$accessToken}`,
          },
          url: me.$apiUrl + '/Liff/GetData_GetUserInfo/A222F382F75747AC9441E37081AF7A1F',
          data: new FormData()
        }
        var url = new URL(location.href)
        config.data.append('invitation_code', new URLSearchParams(url.search).get('inviteCode'));
        swal.fire({
          allowOutsideClick: false
        });
        swal.showLoading();
        axios(config).then(res => {
          var data = res.data;
          if (data && data.success) {
            this.userInfo = data.data
          } else {
            alert(data.message);
          }
        }).catch((err) => {
          console.log(err)
          alert("系統忙碌中，請稍後再試");
        }).finally(() => {
          swal.close();
        })
      },
      changeAeMember(val) {
        this.$set(this.userInfo, "isAeMember", val)
      },

      // 禁止手機橫拿
      // renderResize(){
      //   if (window.orientation == 180 || window.orientation == 0) {
      //     this.showPopup = false
      //   }
      //   if (window.orientation == 90 || window.orientation == -90) {
      //     this.showPopup = true
      //   }
      // }
    },
  };
</script>
<style lang="scss">
  #app {
    max-width: 500px;
    width: 100%;
    margin: 0 auto;
    overflow: hidden;

    footer {
      color: #000000;
      font-size: 12px;
      text-align: center;
      padding-bottom: 10px;
    }

    .nav {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: fixed;
      left: 0;
      top: 0;
      z-index: 5;
      background-color: #EBD559;
      width: 100vw;
      height: 100vh;

      .v-image {
        position: absolute;
        right: 16px;
        top: 8px;
      }

      a {
        display: block;
        line-height: 3;
        color: #000000;
        font-weight: 700;
        font-size: 24px;
        text-decoration: none;
        width: 220px;
        text-align: center;

        &+a {
          position: relative;

          &::before {
            position: absolute;
            left: 0;
            top: 0;
            content: '';
            display: block;
            width: 100%;
            height: 3px;
            background-image: url(./assets/img/line.svg);
          }
        }
      }
    }

    .v-btn {
      margin: auto;

      &:not(.v-btn--round).v-size--default {
        height: auto;
      }

      &:before,
      &.theme--light.v-btn--has-bg,
      &.theme--light.v-btn--disabled {
        background-color: rgb(245 245 245 / 0%) !important;
      }

    }

    .v-btn--is-elevated,
    .v-btn--is-elevated:active {
      box-shadow: none;
    }
  }
</style>